import { useEffect, useId } from "react";

export default function ConfirmDialog({
  open,
  label,
  title,
  description,
  confirmLabel,
  cancelLabel = "Keep editing",
  confirmTone = "danger",
  onConfirm,
  onCancel,
}: {
  readonly open: boolean;
  readonly label?: string;
  readonly title: string;
  readonly description?: string;
  readonly confirmLabel: string;
  readonly cancelLabel?: string;
  readonly confirmTone?: "danger" | "primary";
  readonly onConfirm: () => void;
  readonly onCancel: () => void;
}) {
  const titleId = useId();

  useEffect(() => {
    if (!open) {
      return;
    }
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key !== "Escape") {
        return;
      }
      event.preventDefault();
      onCancel();
    };
    window.addEventListener("keydown", onKeyDown);
    return () => {
      window.removeEventListener("keydown", onKeyDown);
    };
  }, [open, onCancel]);

  if (!open) {
    return null;
  }

  return (
    <section
      className="decision-panel decision-panel--confirm"
      role="dialog"
      aria-modal="true"
      aria-labelledby={titleId}
    >
      <div>
        {label === undefined ? null : <p className="utility-label">{label}</p>}
        <h2 id={titleId}>{title}</h2>
        {description === undefined ? null : <p>{description}</p>}
      </div>
      <div className="decision-actions">
        <button
          className="secondary-action"
          type="button"
          autoFocus
          onClick={onCancel}
        >
          {cancelLabel}
        </button>
        <button
          className={
            confirmTone === "primary" ? "primary-action" : "danger-action"
          }
          type="button"
          onClick={onConfirm}
        >
          {confirmLabel}
        </button>
      </div>
    </section>
  );
}
